import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLoginModal } from '../context/LoginModalContext';
import { isDdhappsAccount } from '../utils/auth';

export default function ProtectedRoute({ children, requireDdhapps = false }) {
  const { user, loading } = useAuth();
  const { openLogin } = useLoginModal();

  useEffect(() => {
    if (!loading && !user) openLogin();
  }, [loading, user, openLogin]);

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  if (requireDdhapps && !isDdhappsAccount(user)) return <Navigate to="/account" replace />;
  return children;
}
